import React, { lazy, type PropsWithChildren, useEffect, useState } from 'react';
import { VpLoader } from '@vtmn-play/react';

import { useAppDispatch } from '../../store/store';
import { addPersonalUserInfo } from '../../store/userInfoSlice';
import { useGetUserInfoQuery } from '../../apis/authentication/useGetUserInfoQuery';
import { LazyReact } from '../LazyReact/LazyReact';
import { setupIntl } from '../../utils/i18n/translations';
import { NAVIGATOR_LANGUAGE } from '../../constants/app';
import { setIcareKo } from '../../store/appSlice';
import { WebServiceError } from '../../utils/apis/WebServiceError';

const ErrorPage = lazy(async () => ({
  default: (await import('../ErrorPage/ErrorPage')).ErrorPage,
}));

export const Authentication = ({ children }: PropsWithChildren) => {
  const dispatch = useAppDispatch();
  const userInfoQuery = useGetUserInfoQuery();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (userInfoQuery.data) {
      const {
        user: { displayName, preferredLanguage, jobname, uid, partyNumber, sitepartynumber },
      } = userInfoQuery.data;

      dispatch(
        addPersonalUserInfo({
          displayName,
          preferredLanguage,
          jobname,
          uid,
          sitePartyNumber: sitepartynumber ?? (Array.isArray(partyNumber) ? partyNumber.at(0) : partyNumber) ?? '',
        })
      );
      setIsReady(true);
    }
  }, [userInfoQuery.data]);

  if (isReady) {
    return children;
  }

  if (userInfoQuery.error instanceof WebServiceError && userInfoQuery.error.status !== 401) {
    void (async () => {
      const { default: translations } = await import(`../../utils/i18n/backupTransl/${NAVIGATOR_LANGUAGE}.json`);
      await setupIntl({ locale: navigator.language, translation: translations });
      dispatch(setIcareKo(true));
    })();
    return (
      <LazyReact>
        <ErrorPage />
      </LazyReact>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        height: '90vh',
        textAlign: 'center',
        flexDirection: 'row',
        gap: '1rem',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      Waiting for authentication&hellip; <VpLoader size="small" />
    </div>
  );
};
